import { useTranslation } from "react-i18next";
import { Navigate, Outlet } from "react-router-dom";
import { Box } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";

import { FilesTab } from "@pages/Settings/ResourceManagement/components/FilesTab";
import { PartnersTab } from "@pages/Settings/ResourceManagement/components/PartnersTab";
import { ProfilesTab } from "@pages/Settings/ResourceManagement/components/ProfilesTab";
import { PromoCodesTab } from "@pages/Settings/ResourceManagement/components/PromoCodesTab";
import { VerificationQueueTab } from "@pages/Settings/ResourceManagement/components/VerificationQueueTab";

import { WithAccountManagementNavbar } from "@layouts/WithAccountManagementNavbar";
import { WithSidebar } from "@layouts/WithSidebar";

import { PAGE_TITLE } from "@constants/index";
import { firstAccessibleAccountPath } from "@data/accountManagementNavLinks";
import { useAuth } from "@contexts/auth";

import { ActivationEngagementTab } from "./components/ActivationEngagementTab";
import { RecruitmentTab } from "./components/RecruitmentTab";
import { RecruitersTab } from "./components/RecruitersTab";


export const AccountManagement = () => {
  const { t } = useTranslation();
  useDocumentTitle(`${t("accounts")} • ${PAGE_TITLE}`);

  return (
    <WithSidebar hasDashboardNavbar>
      <WithAccountManagementNavbar>
        <Box mt="xl">
          <Outlet />
        </Box>
      </WithAccountManagementNavbar>
    </WithSidebar>
  );
};

export const AccountManagementIndex = () => {
  const { canAccessPath } = useAuth();
  return <Navigate to={`/${firstAccessibleAccountPath(canAccessPath)}`} replace />;
};

export const RecruitmentAccounts = RecruitmentTab;
export const RecruitersAccounts = RecruitersTab;
export const VerificationQueueAccounts = VerificationQueueTab;
export const ProfilesAccounts = ProfilesTab;
export const PartnersAccounts = PartnersTab;
export const ActivationEngagementAccounts = ActivationEngagementTab;
export const FilesAccounts = FilesTab;
export const PromoCodesAccounts = PromoCodesTab;
